import script from "./designTask.vue?vue&type=script&setup=true&lang=js"
export * from "./designTask.vue?vue&type=script&setup=true&lang=js"

import "./designTask.vue?vue&type=style&index=0&id=49c65c00&lang=less&scoped=true"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c65c00"]])

export default __exports__